export default "__VITE_ASSET__BXPaQh_0__"